import { Badge, Button, Label, Popover, PopoverSurface, PopoverTrigger, Subtitle2 } from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import React from 'react';

interface Props {
    criteriaName: string;
    criteria: string[];
    onClearCriteria: (criteriaName: string) => void;
}

const PractitionerConsumptionItemFilterComponent = (props: Props) => {

    const PopoverContent = () => {
        return (
            <div>
                <Subtitle2>{props.criteriaName + ' seleccionados'}</Subtitle2>
                <div>
                    <ul style={{ listStyleType: 'none', paddingLeft: '1em' }}>
                        {props.criteria.map((criteria: string) =>
                            <li key={criteria}>{criteria}</li>
                        )}
                    </ul>
                </div>
            </div>
        );
    };

    return (
        <Popover withArrow>
            <PopoverTrigger disableButtonEnhancement>
                <div>
                    <Label>{props.criteriaName}<Badge>{props.criteria?.length}</Badge></Label>
                    <div>
                        <div>
                            {props.criteria.map((criteria: string) =>
                                criteria
                            ).toString()}
                        </div>
                        <Button size="small" appearance="subtle" shape="circular" icon={<Dismiss24Regular />} onClick={() => props.onClearCriteria(props.criteriaName)} />
                    </div>
                </div>
            </PopoverTrigger>

            <PopoverSurface tabIndex={-1}>
                <PopoverContent />
            </PopoverSurface>
        </Popover>
    );

}
export default PractitionerConsumptionItemFilterComponent;
